import Icon24 from '../../components/common/Icon24'

export default function Icon (props) {
  return (
    <Icon24
      {...props}
    />
  )
}
